<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div v-if="bookingContext.is_load" class="w-100 text-center py-5">
        <loader />
      </div>
      <template v-else>
        <div class="w-100 py-5 px-4" v-if="bookingContext.error != ''">
          <ErrorMessage :message="bookingContext.error" />
        </div>
        <template v-else>
          <span id="top-section"></span>
          <!-- NAVBAR -->
          <div class="w-100 position-sticky bg-white position-relative border-form py-3 z-index-1041" style="top: 0;">
            <div class="ga-container py-2">
              <div class="d-flex">
                <div class="lh-1 align-self-center mr-3">
                  <svg @click="bookingContext.goToPage('PosHome')" class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_581_18)">
                      <path
                        d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_581_18">
                        <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="lh-1 align-self-center">
                  <p class="body-1-4 mb-0">Reserve a table</p>
                </div>
              </div>
            </div>
          </div>
          <block :height="20" />

          <!-- DATE -->
          <div class="ga-container">
            <div class="w-100 mb-3">
              <p class="mb-0 body-1-4">Choose Reservation Date</p>
              <p class="mb-0 body-3-3-1">Select the date you plan to dine with us.</p>
            </div>
            <span id="mid-section"></span>
            <div
              class="w-100 mb-3 border-form radius-6 d-flex justify-content-between p-3"
              @click="bookingContext.toggleDetailCalendar()"
              v-if="bookingContext.form.date.startDate != null">
              <div class="align-self-center">
                <p class="mb-0 body-2-4">{{ $formatDate(bookingContext.form.date.startDate) }}</p>
              </div>
              <div class="align-self-center">
                <svg class="lh-1" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.72599 16H14.5849C16.3993 16 17.3022 15.0971 17.3022 13.3087V2.70862C17.3022 0.92024 16.3993 0.0173645 14.5849 0.0173645H2.72599C0.911556 0.0173645 0 0.911558 0 2.70862V13.3087C0 15.1058 0.911556 16 2.72599 16ZM2.59577 14.6022C1.82311 14.6022 1.39772 14.1943 1.39772 13.3868V5.20021C1.39772 4.40151 1.82311 3.9848 2.59577 3.9848H14.6977C15.4704 3.9848 15.9045 4.40151 15.9045 5.20021V13.3868C15.9045 14.1943 15.4704 14.6022 14.6977 14.6022H2.59577ZM6.96255 7.10145H7.47472C7.77861 7.10145 7.8741 7.01464 7.8741 6.71078V6.19858C7.8741 5.89473 7.77861 5.79923 7.47472 5.79923H6.96255C6.65869 5.79923 6.55452 5.89473 6.55452 6.19858V6.71078C6.55452 7.01464 6.65869 7.10145 6.96255 7.10145ZM9.84483 7.10145H10.357C10.6608 7.10145 10.765 7.01464 10.765 6.71078V6.19858C10.765 5.89473 10.6608 5.79923 10.357 5.79923H9.84483C9.54094 5.79923 9.43678 5.89473 9.43678 6.19858V6.71078C9.43678 7.01464 9.54094 7.10145 9.84483 7.10145ZM12.7271 7.10145H13.2393C13.5431 7.10145 13.6473 7.01464 13.6473 6.71078V6.19858C13.6473 5.89473 13.5431 5.79923 13.2393 5.79923H12.7271C12.4232 5.79923 12.3277 5.89473 12.3277 6.19858V6.71078C12.3277 7.01464 12.4232 7.10145 12.7271 7.10145ZM4.08029 9.94032H4.58382C4.89636 9.94032 4.99185 9.85349 4.99185 9.54961V9.03741C4.99185 8.7336 4.89636 8.64677 4.58382 8.64677H4.08029C3.76776 8.64677 3.67227 8.7336 3.67227 9.03741V9.54961C3.67227 9.85349 3.76776 9.94032 4.08029 9.94032ZM6.96255 9.94032H7.47472C7.77861 9.94032 7.8741 9.85349 7.8741 9.54961V9.03741C7.8741 8.7336 7.77861 8.64677 7.47472 8.64677H6.96255C6.65869 8.64677 6.55452 8.7336 6.55452 9.03741V9.54961C6.55452 9.85349 6.65869 9.94032 6.96255 9.94032ZM9.84483 9.94032H10.357C10.6608 9.94032 10.765 9.85349 10.765 9.54961V9.03741C10.765 8.7336 10.6608 8.64677 10.357 8.64677H9.84483C9.54094 8.64677 9.43678 8.7336 9.43678 9.03741V9.54961C9.43678 9.85349 9.54094 9.94032 9.84483 9.94032ZM12.7271 9.94032H13.2393C13.5431 9.94032 13.6473 9.85349 13.6473 9.54961V9.03741C13.6473 8.7336 13.5431 8.64677 13.2393 8.64677H12.7271C12.4232 8.64677 12.3277 8.7336 12.3277 9.03741V9.54961C12.3277 9.85349 12.4232 9.94032 12.7271 9.94032ZM4.08029 12.7878H4.58382C4.89636 12.7878 4.99185 12.6923 4.99185 12.3885V11.8762C4.99185 11.5724 4.89636 11.4856 4.58382 11.4856H4.08029C3.76776 11.4856 3.67227 11.5724 3.67227 11.8762V12.3885C3.67227 12.6923 3.76776 12.7878 4.08029 12.7878ZM6.96255 12.7878H7.47472C7.77861 12.7878 7.8741 12.6923 7.8741 12.3885V11.8762C7.8741 11.5724 7.77861 11.4856 7.47472 11.4856H6.96255C6.65869 11.4856 6.55452 11.5724 6.55452 11.8762V12.3885C6.55452 12.6923 6.65869 12.7878 6.96255 12.7878ZM9.84483 12.7878H10.357C10.6608 12.7878 10.765 12.6923 10.765 12.3885V11.8762C10.765 11.5724 10.6608 11.4856 10.357 11.4856H9.84483C9.54094 11.4856 9.43678 11.5724 9.43678 11.8762V12.3885C9.43678 12.6923 9.54094 12.7878 9.84483 12.7878Z"
                    fill="black" fill-opacity="0.85" />
                </svg>
              </div>
            </div>
            <div class="w-100 pos-calendar height-animated" :class="{
              'active': bookingContext.date_setting.show_calendar
            }">
              <date-range-picker
                class="w-100"
                v-model="bookingContext.form.date"
                auto-apply
                :ranges="false"
                opens="inline"
                :min-date="bookingContext.date_setting.min_date"
                :date-format="bookingContext.dateFormat"
                :single-date-picker="true">
                <template #date="calendar_date">
                  <div class="pos-calendar-item">
                    <p class="font-lato-regular text-14 lh-1 mb-0">{{bookingContext.formatDateNumber(calendar_date.date)}}</p>
                  </div>
                </template>
              </date-range-picker>
              <p class="mb-0 mt-2 body-2 text-danger" v-if="bookingContext.validation_form.date">Please select reservation date</p>
            </div>
          </div>
          <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- TIME -->
          <div class="ga-container">
            <div class="w-100 mb-3">
              <p class="mb-0 body-1-4">Pick Reservation Time</p>
              <p class="mb-0 body-3-3-1">Select a suitable time for your reservation.</p>
            </div>
            <b-dropdown ref="dd_time" variant="link" class="dd-no-p" menu-class="time_dd w-100" no-caret block :disabled="bookingContext.form.date.startDate == null">
              <template #button-content>
                <div
                  class="w-100 mb-3 border-form radius-6 d-flex justify-content-between p-3">
                  <div class="align-self-center lh-1">
                    <p class="mb-0 body-2-2-1 text-danger" v-if="bookingContext.form.date.startDate != null && bookingContext.form.time.list.length == 0"><i>Sorry, there are no time available on this date.</i></p>
                    <template v-else>
                      <p class="mb-0 body-2-4" v-if="bookingContext.form.time.selected != ''">{{ bookingContext.form.time.selected }}</p>
                      <p class="mb-0 body-2-2-1" v-else><i>Select time</i></p>
                    </template>
                  </div>
                  <div class="align-self-center lh-1">
                    <svg class="lh-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.99605 15.9921C12.3704 15.9921 15.9921 12.3626 15.9921 7.99605C15.9921 3.62175 12.3626 0 7.98823 0C3.62175 0 0 3.62175 0 7.99605C0 12.3626 3.62959 15.9921 7.99605 15.9921ZM7.99605 14.6595C4.29593 14.6595 1.34052 11.6962 1.34052 7.99605C1.34052 4.29593 4.28809 1.33268 7.98823 1.33268C11.6884 1.33268 14.6595 4.29593 14.6595 7.99605C14.6595 11.6962 11.6962 14.6595 7.99605 14.6595Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M3.89613 8.84278H7.98823C8.29394 8.84278 8.53697 8.60757 8.53697 8.29397V3.01031C8.53697 2.70458 8.29394 2.46941 7.98823 2.46941C7.68252 2.46941 7.44732 2.70458 7.44732 3.01031V7.75305H3.89613C3.58256 7.75305 3.34738 7.98826 3.34738 8.29397C3.34738 8.60757 3.58256 8.84278 3.89613 8.84278Z"
                        fill="black" fill-opacity="0.85" />
                    </svg>
                  </div>
                </div>
              </template>
              <b-dropdown-item href="#" v-for="(time,index) in bookingContext.form.time.list" :key="index" @click="bookingContext.selectTimeService(time)">
                <p class="body-2-1 mb-0 py-2">{{ time }}</p>
              </b-dropdown-item>
            </b-dropdown>
            <p class="mb-0 mt-2 body-2 text-danger" v-if="bookingContext.validation_form.time">Please select reservation time</p>
          </div>
          <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- GUEST -->
          <div class="ga-container">
            <div class="w-100 mb-3">
              <p class="mb-0 body-1-4">Number of Guests</p>
              <p class="mb-0 body-3-3-1">Specify the total number of people in your party.</p>
            </div>
            <div class="w-100 mb-3 border-form radius-6 p-3">
              <div class="row">
                <div class="col-7 align-self-center lh-1">
                  <p class="mb-0 body-2-4">Adult</p>
                </div>
                <div class="col-5 align-self-center lh-1">
                  <div class="d-flex justify-content-between">
                    <div class="align-self-center">
                      <div class="pos-order-qty border-green" @click="bookingContext.changeQtyGuest('adult','minus')">
                        <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                        </svg>
                      </div>
                    </div>
                    <div class="align-self-center">
                      <p class="mb-0 font-lato text-16">{{ bookingContext.form.guest.adult }}</p>
                    </div>
                    <div class="align-self-center">
                      <div class="pos-order-qty border-green" @click="bookingContext.changeQtyGuest('adult','plus')">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z"
                            class="fill-primary" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span id="for-guest-form"></span>
            <div class="w-100 mb-3 border-form radius-6 p-3">
              <div class="row">
                <div class="col-7 align-self-center lh-1">
                  <p class="mb-0 body-2-4">Child</p>
                </div>
                <div class="col-5 align-self-center lh-1">
                  <div class="d-flex justify-content-between">
                    <div class="align-self-center">
                      <div class="pos-order-qty border-green" @click="bookingContext.changeQtyGuest('child','minus')">
                        <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                        </svg>
                      </div>
                    </div>
                    <div class="align-self-center">
                      <p class="mb-0 font-lato text-16">{{ bookingContext.form.guest.child }}</p>
                    </div>
                    <div class="align-self-center">
                      <div class="pos-order-qty border-green" @click="bookingContext.changeQtyGuest('child','plus')">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z"
                            class="fill-primary" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- CONTACT INFORMATION -->
          <div class="ga-container">
            <p class="mb-0 body-1-4">Your Contact Details</p>
            <p class="mb-3 body-3-3-1">Provide your information for reservation confirmation.</p>
            <GuestForm ref="guestFormMobile" type="TABLE"></GuestForm>
          </div>
          <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- NOTES -->
          <div class="ga-container">
            <p class="mb-0 body-1-4">Special Requests</p>
            <p class="mb-3 body-3-3-1">Any preferences or special requests? Let us know!</p>
            <textarea class="p-2-5 body-2-1 w-100 border-form radius-6" row="3" v-model="bookingContext.form.notes"></textarea>
          </div>
          <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- BUTTON -->
          <div class="ga-container pb-5">
            <div class="mb-3" v-if="bookingContext.error_push != ''">
              <ErrorMessage :message="bookingContext.error_push" />
            </div>

            <state-button variant="primary" size="lg" block :click="bookingContext.submitForm">Book Now</state-button>
          </div>

        </template>
      </template>
    </b-col>
  </b-row>
</template>

<script>
  import GuestForm from '@/components/hotel/concierge/pos/GuestForm';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

  export default {
    components:{
      DateRangePicker,
      GuestForm
    },
    inject: ['bookingContext'],
    methods: {
      validateGuestForm() {
        return this.$refs.guestFormMobile.validateForm()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/BookingTableMobileLayout.vue